// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase web configuration is public metadata, but production must never
// silently boot with placeholder project identifiers. Keep all deployment values
// in the environment so a misconfigured build fails immediately.
const firebaseEnv = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const requiredFirebaseKeys = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
const missingFirebaseKeys = requiredFirebaseKeys.filter((key) => !String(firebaseEnv[key] || '').trim());
if (process.env.NODE_ENV === 'production' && missingFirebaseKeys.length) {
    throw new Error(`Missing Firebase production configuration: ${missingFirebaseKeys.join(', ')}`);
}
if (process.env.NODE_ENV !== 'production' && missingFirebaseKeys.length) {
    console.warn(`[Firebase] Missing development configuration: ${missingFirebaseKeys.join(', ')}`);
}

const firebaseConfig = {
    apiKey: firebaseEnv.apiKey || 'your-api-key',
    authDomain: firebaseEnv.authDomain || 'your-auth-domain',
    projectId: firebaseEnv.projectId || 'your-project-id',
    storageBucket: firebaseEnv.storageBucket || 'your-storage-bucket',
    messagingSenderId: firebaseEnv.messagingSenderId || 'your-sender-id',
    appId: firebaseEnv.appId || 'your-app-id',
    ...(firebaseEnv.measurementId ? { measurementId: firebaseEnv.measurementId } : {}),
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || process.env.REACT_APP_FUNCTIONS_REGION || 'us-central1');

export { app, auth, db, storage, functions, firebaseConfig };
export default app;